// Image imports
import dubai1 from '../../Images/International/Dubai/dubai1.jpg';
import dubai2 from '../../Images/International/Dubai/dubai2.jpg';
import dubai3 from '../../Images/International/Dubai/dubai3.jpg';
import dubai4 from '../../Images/International/Dubai/dubai4.jpg';
import dubai5 from '../../Images/International/Dubai/dubai5.jpg';
import dubai6 from '../../Images/International/Dubai/dubai6.jpg';
import japan1 from '../../Images/International/Japan/japan1.jpg';
import japan2 from '../../Images/International/Japan/japan2.jpg';
import japan3 from '../../Images/International/Japan/japan3.jpg';
import japan4 from '../../Images/International/Japan/japan4.jpg';
import japan5 from '../../Images/International/Japan/japan5.jpg';
import japan6 from '../../Images/International/Japan/japan6.jpg';
import mauritius1 from '../../Images/International/Mauritius/Mauritius1.jpg';
import mauritius2 from '../../Images/International/Mauritius/Mauritius2.jpg';
import mauritius3 from '../../Images/International/Mauritius/Mauritius3.jpg';
import mauritius4 from '../../Images/International/Mauritius/Mauritius4.jpg';
import mauritius5 from '../../Images/International/Mauritius/Mauritius5.jpg';
import mauritius6 from '../../Images/International/Mauritius/Mauritius6.jpg';
import cambodia1 from '../../Images/International/Combodia/combodia1.jpg';
import cambodia2 from '../../Images/International/Combodia/combodia2.jpg';
import cambodia3 from '../../Images/International/Combodia/combodia3.jpg';
import cambodia4 from '../../Images/International/Combodia/combodia4.jpg';
import cambodia5 from '../../Images/International/Combodia/combodia5.jpg';
import cambodia6 from '../../Images/International/Combodia/combodia6.jpg';
import cambodia7 from '../../Images/International/Combodia/combodia7.jpg';
import cambodia8 from '../../Images/International/Combodia/combodia8.jpg';
import cambodia9 from '../../Images/International/Combodia/combodia9.jpg';
import indo1 from '../../Images/International/indo/indo1.jpg';
import indo2 from '../../Images/International/indo/indo2.jpg';
import indo3 from '../../Images/International/indo/indo3.jpg';
import indo4 from '../../Images/International/indo/indo4.jpg';
import indo5 from '../../Images/International/indo/indo5.jpg';
import indo6 from '../../Images/International/indo/indo6.jpg';
import laos1 from '../../Images/International/Laos/Laos1.jpg';
import laos2 from '../../Images/International/Laos/laos2.jpg';
import laos3 from '../../Images/International/Laos/laos3.jpg';
import laos4 from '../../Images/International/Laos/loas4.jpg';
import laos5 from '../../Images/International/Laos/laos5.jpg';
import laos6 from '../../Images/International/Laos/laos6.jpg';
import vietnam1 from '../../Images/International/Vie/vie1.jpg';
import vietnam2 from '../../Images/International/Vie/vie2.jpg';
import vietnam3 from '../../Images/International/Vie/vie3.jpg';
import vietnam4 from '../../Images/International/Vie/vie4.jpg';
import vietnam5 from '../../Images/International/Vie/vie5.jpg';
import vietnam6 from '../../Images/International/Vie/vie6.jpg';


const internationalLocations = {
  Dubai: [
    {
      id: "DubaiOne",
      title: "Dubai",
      description: "Dubai is a dazzling city in the UAE known for its futuristic skyline, luxury shopping, and world-class attractions.",
      images: [dubai1, dubai2, dubai3],
      region: "Dubai",
      tripDuration: "04 Nights / 05 Days",
      Startpoint: "Dubai",
      Endpoint: "Abu Dubai",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "Dubaitwo",
      title: "Dubai",
      description: "Perfect for adventure, culture, and luxury – Dubai is where desert dreams meet modern marvels.",
      images: [dubai4, dubai5, dubai6],
      region: "Dubai",
      tripDuration: "06 Nights / 07 Days",
      Startpoint: "Dubai",
      Endpoint: "Dubai",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "DubaiThree",
      title: "Dubai",
      description: "From the towering Burj Khalifa to the man-made Palm Islands, it blends innovation with Arabian charm.",
      images: [dubai1, dubai2, dubai6],
      region: "Dubai",
      tripDuration: "08 Nights / 09 Days",
      Startpoint: "Dubai",
      Endpoint: "Dubai",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    }
  ],

  Japan: [
    {
      id: "JapanOne",
      title: "Japan",
      description: "Explore Japan’s temples, cherry blossoms, and futuristic cities.",
      images: [japan1,japan2,japan3],
      region: "Japan",
      tripDuration: "03 Nights / 04 Days",
      Startpoint: "Japan",
      Endpoint: "Japan",
      features: ["Accommodation", "Meals ", "Cultural Experiences", "Guides"]
    },
    {
      id: "JapanTwo",
      title: "Japan",
      description: "Captivating blend of ancient tradition and cutting-edge modernity, known for its rich culture, technology, and natural beauty.",
      images: [japan5,japan4,japan6],
      region: "Japan",
      tripDuration: "06 Nights / 07 Days",
      Startpoint: "Japan",
      Endpoint: "Japan",
      features: ["Accommodation", "Meals ", "Cultural Experiences", "Guides"]
    }
  ],

  Mauritius: [
    {
      id: "MauritiusOne",
      title: "Mauritius",
      description: "Mauritius is a tropical paradise known for its stunning beaches, coral reefs, and lush landscapes.",
      images: [mauritius2,mauritius2,mauritius3],
      region: "Mauritius",
      tripDuration: "04 Nights / 05 Days",
      Startpoint: "Mauritius",
      Endpoint: "Mauritius",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "MauritiusTwo",
      title: "Mauritius",
      description: "A blend of cultures, stunning beaches, and vibrant marine life make it a perfect getaway.",
      images: [mauritius5,mauritius5,mauritius6],
      region: "Mauritius",
      tripDuration: "06 Nights / 07 Days",
      Startpoint: "Mauritius",
      Endpoint: "Mauritius",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    }
  ],

  Cambodia : [
    {
      id: "CambodiaOne",
      title: "Cambodia",
      description: "Cambodia is known for its ancient temples, rich history, and vibrant culture.",
      images: [cambodia1,cambodia2,cambodia3],
      region: " Siem Reap",
      tripDuration: " 03 Nights / 04 Days",
      Startpoint: " Siem Reap",
      Endpoint: " Siem Reap",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "CambodiaTwo",
      title: "Cambodia",
      description: "5 Days tour covering Phnom Penh - Phnom Penh Exploration - Siem Reap - Siem Reap Exploration.",
      images: [cambodia4,cambodia5,cambodia6],
      region: "Cambodia",
      tripDuration: "04 Nights / 05 Days",
      Startpoint: "Phnom Penh",
      Endpoint: "Siem Reap Exploration",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "CambodiaThree",
      title: "Cambodia",
      description: "7 Days tour covering Siem Reap - Siem Reap Exploration - Phnom Penh - Sihanouk Ville - Boat Trip - Taman Mini.",
      images: [cambodia7,cambodia8,cambodia9],
      region: "Cambodia",
      tripDuration: "06 Nights / 07 Days",
      Startpoint: "Siem Reap",
      Endpoint: "Taman Mini",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    }
  ],
   
  Indonesia: [
    {
      id: "IndonesiaOne",
      title: "Jakarta",
      description: "Sri Lanka is an island nation known for its stunning beaches, lush landscapes, and rich cultural heritage.",
      images: [indo1,indo2,indo3],
      region: "Jakarta",
      tripDuration: " 02 Nights / 03 Days",
      Startpoint: "Jakarta",
      Endpoint: "Jakarta",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "IndonesiaTwo",
      title: "Bali",
      description: "A blend of culture, wildlife, and stunning landscapes make it a perfect getaway.",
      images: [indo4,indo5,indo6],
      region: "Bali",
      tripDuration: "02 Nights / 03 Days",
      Startpoint: "Bali",
      Endpoint: "Bali",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "IndonesiaThree",
      title: "Enchanting Bali Tour",
      description: "4 Days covering Arrival Bali - Barong And Volcano Tour - Bedugul And Tanah Lot Tour",
      images: [indo1,indo2,indo3],
      region: " Indonesia",
      tripDuration: "03 Nights / 04 Days",
      Startpoint: "Bali",
      Endpoint: "Bedugul And Tanah Lot Tour",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    }
  ],

  Laos: [
    {
      id: "LaosOne",
      title: "Laos",
      description: "Laos is known for its mountainous terrain, French colonial architecture, and Buddhist monasteries.",
      images: [laos1,laos2,laos3],
      region: "Luang Prabang",
      tripDuration: "03 Nights / 04 Days",
      Startpoint: "Luang Prabang",
      Endpoint: "Luang Prabang",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "LaosTwo",
      title: "Laos",
      description: "6 Days tour covering Vientiane–Vang Vieng-Luang Prabang-Pak Ou",
      images: [laos6,laos4,laos5],
      region: "Laos",
      tripDuration: "05 Nights / 06 Days",
      Startpoint: "Vientiane",
      Endpoint: "Pak Ou",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "LaosThree",
      title: "Laos",
      description: "8 Days Tour covering  Luang Prabang-Vientiane-Tad Lo-4000 Islands and surrounding areas.",
      images: [laos3,laos4,laos6],
      region: "Laos",
      tripDuration: "07 Nights / 08 Days",
      Startpoint: "Luang Prabang",
      Endpoint: "4000 Islands and surrounding",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    }
  ],

  Vietnam: [
    {
      id: "VietnamOne",
      title: "Vietnam",
      description: "Vietnam is known for its beaches, rivers, and Buddhist pagodas.",
      images: [vietnam1,vietnam2,vietnam3],
      region: "Hanoi",
      tripDuration: "05 Nights / 06 Days",
      Startpoint: "Hanoi",
      Endpoint: "Hanoi",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    },
    {
      id: "VietnamTwo",
      title: "Vietnam",
      description: "8 Days tour covering Hanoi-Ho Chi Minh City-Siem Reap ares.",
      images: [vietnam4,vietnam5,vietnam6],
      region: "Vietnam",
      tripDuration: "07 Nights / 08 Days",
      Startpoint: "Hanoi",
      Endpoint: "Siem Reap",
      features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
    }
  ],

};

export default internationalLocations;
